export default "__VITE_ASSET__M$zyHpHB__";